// removed by extract-text-webpack-plugin
module.exports = {"professionalContactUs":"_2DG9bN9l26p7zJv_BzbXXa","title":"Hj0MW5POcnKgJsaNGYqq5","description":"_1fQCcrS3krPGcYIpVrvpUJ","horizontalBlock":"_2v9-dqGPGyofLv49cK3meV","companyTypeWrap":"_1RK-IDFvXJ7MRWKBcevh3_","textWrapper":"_2JZlVqAUhoTDk9ZjQ909PM","textAreaWrapper":"W33d-g-dAJiqXKLVIBax-","label":"ZhsG06V9wJo2PWf8nd_A_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalContactUs/ProfessionalContactUs.scss
// module id = 1696
// module chunks = 0